function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgShare = function SvgShare(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Share' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M16,30.707 L14,30.707 C14,19.698 22.832,11.707 35,11.707 L44.586,11.707 L34.293,1.414 L35.707,0 L48.414,12.707 L35.707,25.414 L34.293,24 L44.586,13.707 L35,13.707 C23.813,13.707 16,20.698 16,30.707"
  }), React.createElement("polygon", {
    points: "40 43.707 0 43.707 0 9.707 13 9.707 13 11.707 2 11.707 2 41.707 38 41.707 38 30.707 40 30.707"
  }));
};

SvgShare = pure(SvgShare);
SvgShare.displayName = 'SvgShare';
export default SvgShare;